import React, { Component } from "react";
import { push } from "../Services/Analytics"

import "./Header.scss"

import dataJSON from "../../api/FooterBanner.json"

class Header extends Component {
  constructor() {
    super()
    this.state = {
    }
    this.shareBTN = this.shareBTN.bind(this);
  }
  shareBTN(action) {
    var shareText = "מצאנו דרך להפוך את היום שלך מסתם טוב למצוין";
    var url = "https://z.ynet.co.il/mshort/commerce/2018/EvenBetterGlow/";
    switch (action) {
      default:
      case "facebook":
        push("Share_Facebook", url);
        window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(url) + "&redirect_uri=" + encodeURIComponent(url), "_blank");
        break;
      case "twitter":
        push("Share_Twitter", url);
        window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(window.document.title) + "&url=" + encodeURIComponent(url), "_blank");
        break;
      case "whatsapp":
        push("Share_WhatsApp", url);
        window.open("whatsapp://send?text=" + encodeURIComponent(shareText + " >> " + url), "_parent");
        break;
      case "negishut":
        push("Accessibility", "Open_Accessibility_Clicked");
        var elem = window.document.getElementById('INDmenu-btn');
        var event = new Event('click');
        elem.dispatchEvent(event);
        break;
    }
  }
  linkDataLayer() {
    push("Purchase_Button_Clicked", "Purchase_Logo_Clicked");
    window.open(dataJSON.link, "_blank");
  }
  render() {
    return (
      <header>
        <div id="header">
          <div className="padding">
            <div className="container">
              <div className="logos">
                <div className="pblogo"></div>
                <div className="sponslogo" onClick={this.linkDataLayer}></div>
              </div>
              <div className="share">
                <a href="https://xnet.ynet.co.il/" title="Xnet" target="_blank"><div className="xnet"></div></a>
                <div onClick={() => { this.shareBTN("twitter") }} className="twitter"></div>
                <div onClick={() => { this.shareBTN("whatsapp") }} className="whatsapp"></div>
                <div onClick={() => { this.shareBTN("facebook") }} className="facebook"></div>
                <div onClick={() => { this.shareBTN("negishut") }} className="negishut"></div>
              </div>
            </div>
          </div>
        </div>
        <div id="virtual-header"></div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.js